import { getPosthog } from './posthog'

export const identifyUser = (uid, userPropsSetOnce = {}, userPropsSet = {}) => {
  getPosthog().identify(uid, userPropsSetOnce, userPropsSet)
}

export const trackPageView = () => getPosthog().capture('$pageview')

export const track = (event, props) => getPosthog().capture(event, props)
